import {setAlert} from "./alert";
import {RESERVATION_TEMP_TIMEOUT} from "../../constants/reservation-constants";
import {
    addBilleterieTemp, calculateSumarryAmounts, deleteReservationTemp, updateReservationTempTimeout
} from "../../server/services/reservation-service";
import SessionKeys from "../../session";
import {
    GET_SHOP, ADD_TO_SHOPPING_CART, REMOVE_FROM_SHOPPING_CART, UPDATE_SHOP, // CLEAR_SHOP,
    SHOP_ERROR, SET_FRAIS_ADMIN, SET_TAUX_TAXES, CLEAR_TIMEOUT_SHOP, INITIALIZE_SHOPPING_CART, UPDATE_PROMOTIONS, INITIALIZE_PROMOTIONS, REMOVE_PROMOTION, RECALCULER_SHOP, CLEAR_PROMOTION, UPDATE_MONTANT_DEPOT, IS_RECALCULING
} from "./types";
import {api} from "../../server/api";
import {hidePopup} from "./generic-popup";
import {setReload} from "./form-pop-active";
import {parseJSON} from "date-fns";
import {getEntrepriseIsFromQuebec} from "../../server/services/entreprise-service";
import {getConfigurationByKeyName} from "../../server/services/configuration-service";
import {getBilletterieImage} from "../../server/services/catalogue-service";
import {differenceInDays} from "date-fns"

export const CartItemType = {
    // Nommé selon la naming convention de Google pour les énumérations: https://google.github.io/styleguide/javascriptguide.xml?showone=Naming#Naming
    Forfait: "forfait", ReservationActivite: "Reservation d'activité", ReservationCamping: "Reservation Camping", ReservationAutre: "Reservation Activité", ReservationHebergement: "Reservation Hebergement", CommandeRestaurant: "Commande restaurant", Billetterie: "Billet", Tirage: 'Tirage', CampJour: 'CampJour', Activite: 'Activite', Boutique: "boutique"
}
;

let TPS = 0.05;
let TVQ = 0.09975;
let isFraisAdminGlobal = false;
let nombreUniteMax = 1;
/**Time out pour la mise à jour de l'expiration dans la table temporaire */
var timeoutId;

function roundTwoDecimals(n) {
    return Math.round(n * 100) / 100;
}

// Get shop
export const getShop = () => async (dispatch) => {
    try {
        dispatch({
            type: GET_SHOP
        });
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.response.statusText, status: err.response.status
            }
        });
        dispatch(setAlert(err, "danger"));
    }
};

export const initializeShoppingCart = (payload) => async (dispatch, getState) => {
    // Modifié par Max
    const safeCart = Array.isArray(payload?.cart) ? payload.cart : [];
    const safePromotions = Array.isArray(payload?.promotions) ? payload.promotions : [];
    dispatch({
        type: INITIALIZE_SHOPPING_CART, payload: {cart: safeCart, promotions: safePromotions}
    });
    //

    try {
        // const {cart: cart, promotions} = payload;

        // Modifié par Max
        const cart = safeCart;
        const promotions = safePromotions;
        //

        let idsRrsvTemp = [];
        let hasReservation = false;
        let isFromQuebec = false;
        getEntrepriseIsFromQuebec().then((isFromQc) => {
            isFromQuebec = isFromQc;
            if (!isFromQc) {
                TPS = 0.15
                TVQ = 0;
            }
        });

        getConfigurationByKeyName("MODE_CALCUL_FRAIS_SERVICES_WEB").then((config) => {
            isFraisAdminGlobal = config.keyValue === "0";
        })

        getConfigurationByKeyName("NOMBRE_LIMITE_UNITES_PANIER_WEB").then(({keyValue}) => {
            nombreUniteMax = parseInt(keyValue);
        }).catch(() => nombreUniteMax = 1)

        if (cart) {
            for (let i = 0; i < cart.length; i++) {
                const cartItem = cart[i];

                if (cartItem.type && cartItem.type.includes("Reservation")) {
                    // Quels types de cart items ont 'Reservation' à part 'Reservation d'activité'?
                    idsRrsvTemp = idsRrsvTemp.concat(cartItem.idsReservationTemp);
                    hasReservation = true;
                }
                if (cartItem.selectedDate) cartItem.selectedDate = new Date(cartItem.selectedDate);
            }
        }

        dispatch(setTimeoutShop(idsRrsvTemp));
        if (hasReservation) {
            /* const currentState = getState();
             api.post("Reservation/MontantsDepot", JSON.stringify({shop: {...currentState.shop, promotions: promotions || [], cart: cart || []}})).then(depot => {
                 const montantDepot = cart?.reduce((montantDepotAutre, curItem) => {
                     if (!curItem.type.includes("Reservation")) {
                         return montantDepotAutre + curItem["total"] || 0
                     }
                     return montantDepotAutre;
                 }, 0)
                 dispatch({
                     type: UPDATE_MONTANT_DEPOT, payload: {
                         ...depot, montant: depot.montant + montantDepot || 0
                     }
                 })
             });*/
        } else {
            const montantDepot = cart?.reduce((montantDepotAutre, curItem) => {
                if (!curItem.type.includes("Reservation")) {
                    return montantDepotAutre + curItem["total"] || 0
                }
                return montantDepotAutre;
            }, 0)
            dispatch({
                type: UPDATE_MONTANT_DEPOT, payload: {
                    montant: montantDepot || 0
                }
            })
        }

        // Modifié par Max
        // await dispatch({
        //     type: INITIALIZE_SHOPPING_CART, payload: {
        //         cart: cart || [], promotions: promotions || []
        //     }
        // })
        await dispatch(recalculerShop());
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.response.statusText || err, status: err.response.status
            }
        });
    }
};

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const onAddUpdateShoppingCart = (childIndex, boutiqueItem, showAlert = true, lang = 'fr') => async (dispatch, getState) => {
    const {shop} = getState();
    const childNum = childIndex + 1;
    const campItemId = `inscriptionCampJour_enfant${ childNum }`;
    const campItemIdPrefix = `${ campItemId }_`;
    const campIndex = shop.cart.findIndex(item => item.type === CartItemType.CampJour && item.id && (item.id === campItemId || item.id.startsWith(campItemIdPrefix)));
    if (campIndex < 0) {
        return dispatch(addToShoppingCart(boutiqueItem, showAlert, lang));
    }
    const campItem = shop.cart[campIndex];
    let productMontant = 0;
    let productTps = 0;
    let productTvq = 0;
    const selectedProductsToAdd = [];
    if (boutiqueItem.produitPrix && boutiqueItem.produitPrix.length) {
        boutiqueItem.produitPrix.forEach(e => {
            const qty = Number(e.quantite) || 0;
            if (qty > 0) {
                const unitPrix = e.prix ?? boutiqueItem.prix ?? 0;
                productMontant += unitPrix * qty;
                selectedProductsToAdd.push({
                    idProduit: e.idProduit || boutiqueItem.idProduit || boutiqueItem.id, idProduitPrix: e.idProduitPrix || EMPTY_GUID, quantite: qty
                });
            }
        });
    } else {
        productMontant = Number(boutiqueItem.montant) || 0;
        selectedProductsToAdd.push({
            idProduit: boutiqueItem.idProduit || boutiqueItem.id, idProduitPrix: EMPTY_GUID, quantite: 1
        });
    }
    const taxableTps = boutiqueItem.taxableTps !== false;
    const taxableTvq = boutiqueItem.taxableTvq !== false;
    productTps = roundTwoDecimals(taxableTps ? productMontant * TPS : 0);
    productTvq = roundTwoDecimals(taxableTvq ? productMontant * TVQ : 0);
    const productTotal = roundTwoDecimals(productMontant + productTps + productTvq);
    const inscriptionCamp = campItem.inscriptionCamp || {trajetsAutobus: [], selectedProducts: []};
    const existingSelected = Array.isArray(inscriptionCamp.selectedProducts) ? inscriptionCamp.selectedProducts : [];
    const existingInclus = Array.isArray(campItem.inclus) ? campItem.inclus : [];
    const productInclus = Array.isArray(boutiqueItem.inclus) ? boutiqueItem.inclus : [];
    const inclusToAdd = productInclus.length > 0 ? productInclus : [{name: `${ boutiqueItem.name || '' }: 1 x ${ Number(boutiqueItem.montant || 0).toFixed(2) }$`, textVal: '', value: ''}];
    const updatedCampItem = {
        ...campItem, inscriptionCamp: {
            ...inscriptionCamp, selectedProducts: [...existingSelected, ...selectedProductsToAdd]
        }, inclus: [...existingInclus, ...inclusToAdd], montant: roundTwoDecimals(Number(campItem.montant) + productMontant), tps: roundTwoDecimals(Number(campItem.tps) + productTps), tvq: roundTwoDecimals(Number(campItem.tvq) + productTvq), taxableTps: taxableTps, taxableTvq: taxableTvq, total: roundTwoDecimals(Number(campItem.total) + productTotal)
    };
    if (showAlert) {
        if (lang === 'fr') dispatch(setAlert((boutiqueItem.name || '').toUpperCase() + " a été ajouté au camp de l'enfant", "success")); else dispatch(setAlert((boutiqueItem.name || '').toUpperCase() + " was added to the child's camp", "success"));
    }
    return dispatch(updateShop(campIndex, updatedCampItem, false, lang));
};

// Add an item to the shopping cart
export const addToShoppingCart = (newItem, showAlert = true, lang = 'fr') => async (dispatch, getState) => {
    //console.log(newItem);
    const {shop} = getState();
    try {
        let depot = 0;
        //newItem['tps'] = (newItem['montant'] * TPS); // Certain clients ne paie pas de tps/tvq, certains produits ne sont pas taxés, et certains produits ont les taxes inclusent. Pour cette raison, on ne peut pas calculer les taxes en multipliant le montant par le taux de taxe.
        //newItem['tvq'] = (newItem['montant'] * TVQ); // Certain clients ne paie pas de tps/tvq, certains produits ne sont pas taxés, et certains produits ont les taxes inclusent. Pour cette raison, on ne peut pas calculer les taxes en multipliant le montant par le taux de taxe.
        //newItem['total'] = (Number(newItem['montant']) + Number(newItem['tps']) + Number(newItem['tvq']));
        if (newItem["type"].includes("Reservation")) {
            if (!newItem["idsReservationTemp"]) {
                if (lang === 'en') {
                    await dispatch(setAlert("An unexpected error has occurred that has prevented the selected unite from being added to your cart, please try again.", "danger"));
                } else {
                    await dispatch(setAlert("Une erreur inattendue s'est produite et a empêché l'ajout de l'unité sélectionné dans votre panier, veuillez réessayer.", "danger"));
                }
                throw new Error("Une erreur s'est produite lors de l'ajout au panier, veuillez réessayer.");
            }

            if (nombreUniteMax !== 0 && shop.cart.filter(f => f.type.includes("Reservation")).length >= nombreUniteMax) {
                if (lang === 'en') {
                    await dispatch(setAlert(`You cannot book more then ${ nombreUniteMax } stays at the same time, first complete the stay already in the cart`, "danger"));
                } else {
                    await dispatch(setAlert(`Vous ne pouvez pas réserver plus de ${ nombreUniteMax } séjour(s) à la fois, complétez votre réservation au panier`, "danger"));
                }
                deleteReservationTemp(newItem["idsReservationTemp"]);
                throw new Error(`Vous ne pouvez pas réserver plus de ${ nombreUniteMax } séjours à la fois, complétez votre réservation au panier`);
            }

            if (shop.cart.filter(f => f.type.includes("Reservation")).some(s => {
                const dateDebutItem = parseJSON(s.selectedUnite.selectedArrivee);
                const dateFinItem = parseJSON(s.selectedUnite.selectedDepart);
                const dateDebutNewItem = parseJSON(newItem.selectedUnite.selectedArrivee);
                const dateFinNewItem = parseJSON(newItem.selectedUnite.selectedDepart);

                return s.type.includes("Reservation") && differenceInDays(dateDebutNewItem, dateFinItem) > 0 && (dateFinNewItem < dateDebutItem || dateDebutNewItem > dateFinItem)
            })) {
                if (lang === 'en') {
                    await dispatch(setAlert("You cannot book for 2 separate stays, first complete the stay already in the cart", "danger"));

                } else {
                    await dispatch(setAlert("Vous ne pouvez pas réserver pour 2 séjours distincts, complétez votre réservation au panier", "danger"));
                }
                throw new Error("Vous ne pouvez pas réserver pour 2 séjours distincts, complétez votre réservation au panier");
            }

            // Quels types de cart items ont 'Reservation' à part 'Reservation d'activité'?
            var montants = await calculateSumarryAmounts(newItem["selectedUnite"]);

            if (montants.montantDetailles.some(mntDetail => mntDetail.description === "Invalide")) throw new Error(lang === 'en' ? "Error when calculating the rate" : 'Erreur lors du calcul du tarif')

            if (Object.keys(montants).length === 0) {
                newItem["fraisAdmin"] = 0;
                newItem["hebergement"] = 0;
                newItem["tps"] = newItem["montant"] * TPS;
                newItem["tvq"] = newItem["montant"] * TVQ;
                newItem["total"] = Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]);
                newItem["montantDepots"] = newItem["total"];
                depot += newItem["total"];
            } else {

                newItem["montant"] = montants.montantAvantTaxes;
                newItem["fraisAdmin"] = isFraisAdminGlobal && shop.cart.length >= 1 ? 0 : montants.fraisAdmin;
                newItem["hebergement"] = montants.hebergement;
                newItem["tps"] = montants.tps;
                newItem["tvq"] = montants.tvq;
                newItem["total"] = montants.total;
                /*const montantDepot = montants.montantDepots.find((mntDepot) => mntDepot.noDepot === 1);
                newItem["montantDepots"] = montantDepot ? montantDepot.montant : montants.total;
                newItem["isMontantDepotFix"] = montantDepot ? montantDepot.is_depot_fix : false;*/
                newItem["montantDetail"] = montants.montantDetailles;
            }
            //effacer les donnees du pop fom activite
            if (newItem['selectedUnite']?.type_hebergement === 'AC') {
                await dispatch(hidePopup())
            }
            var currentState = getState();
            //la condition est juste pour permettre l'ajout des activites dans le panier cela doit disparaitre une fois que les element de l'activite sont OK
            if (!(newItem['selectedUnite']?.type_hebergement === 'AC')) {
                const promotionValides = await api.post("promotion/getPromotionApplicableAuto", JSON.stringify({shop: currentState.shop}))
                if (Array.isArray(promotionValides)) {
                    await promotionValides.forEach((promotionValide) => {
                        dispatch(updatePromotions(promotionValide, false));
                    });
                }
            }


        } else if (newItem["type"] === CartItemType.CampJour) {

            if (newItem["tps"] === undefined || newItem["tvq"] === undefined || newItem["total"] === undefined || newItem["montantDepots"] === undefined || newItem["hebergement"] === undefined || newItem["fraisAdmin"] === 0) {
                // Bloc temporaire en attendant que le site calcule les taxes correctement partout
                newItem["tps"] = newItem["taxableTps"] || newItem["taxableTps"] === undefined ? newItem["montant"] * TPS : 0;
                //newItem['tvq'] = roundTwoDecimals(newItem['montant'] * TVQ + newItem['montant'] * TPS - newItem['tps']); // Ce "+ newItem['montant'] * TPS - newItem['tps']" corrige les erreurs d'arrondissement de cents (e.g. round(3.333 + 3.333) = 6.67 mais round(3.33) + round(3.33) = 6.66. Le Manisoft met la cet supplémentaire dans la TVQ).
                newItem["tvq"] = newItem["taxableTvq"] || newItem["taxableTvq"] === undefined ? newItem["montant"] * TVQ : 0; // Corriger l'arrondissement de cents seulement à la fin lors du calcul du total
                newItem["total"] = Math.round((Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]) + Number.EPSILON) * 100) / 100;
                newItem["fraisAdmin"] = 0;
                newItem["hebergement"] = 0;
                newItem["montantDepots"] = newItem["total"];
                depot += newItem["total"];
            }

            if (!newItem.image) {
                const idProduit = newItem.idProduitAge;
                if (idProduit) {
                    try {
                        const imgResponse = await getBilletterieImage(idProduit);
                        const img = imgResponse?.data ?? imgResponse;
                        if (Array.isArray(img) && img[0]?.image) {
                            newItem.image = `data:image/jpeg;base64,${ img[0].image }`;
                        }
                    } catch (e) {
                        // Ne pas bloquer l'ajout au panier si l'image échoue
                    }
                }
            }
        } else {
            if (newItem["tps"] === undefined || newItem["tvq"] === undefined || newItem["total"] === undefined || newItem["montantDepots"] === undefined || newItem["hebergement"] === undefined || newItem["fraisAdmin"] === 0) {
                // Bloc temporaire en attendant que le site calcule les taxes correctement partout
                newItem["tps"] = newItem["taxableTps"] || newItem["taxableTps"] === undefined ? (newItem["montantTaxableTps"] || newItem["montant"]) * TPS : 0;
                //newItem['tvq'] = roundTwoDecimals(newItem['montant'] * TVQ + newItem['montant'] * TPS - newItem['tps']); // Ce "+ newItem['montant'] * TPS - newItem['tps']" corrige les erreurs d'arrondissement de cents (e.g. round(3.333 + 3.333) = 6.67 mais round(3.33) + round(3.33) = 6.66. Le Manisoft met la cet supplémentaire dans la TVQ).
                newItem["tvq"] = newItem["taxableTvq"] || newItem["taxableTvq"] === undefined ? (newItem["montantTaxableTvq"] || newItem["montant"]) * TVQ : 0; // Corriger l'arrondissement de cents seulement à la fin lors du calcul du total
                newItem["total"] = Math.round((Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]) + Number.EPSILON) * 100) / 100;
                newItem["fraisAdmin"] = 0;
                newItem["hebergement"] = 0;
                newItem["montantDepots"] = newItem["total"];
                depot += newItem["total"];
            }
            if (!newItem["idsReservationTemp"] || newItem["idsReservationTemp"].length === 0) {
                const result = await addBilleterieTemp({
                    idProduit: newItem["idProduit"], quantite: newItem["quantite"] || 1,
                });

                //newItem["id"]=result;
                newItem["idsReservationTemp"] = [result];
            }
        }

        if (showAlert) {
            if (lang === 'en') dispatch(setAlert(newItem.name + " added to the shopping cart", "success")); else dispatch(setAlert(newItem.name + " a été ajouté au panier", "success"));
        }
        await dispatch({
            type: ADD_TO_SHOPPING_CART, payload: newItem
        });
        await dispatch(clearPromotion());
        currentState = getState();
        const promotionValides = await api.post("promotion/getPromotionApplicableAuto", JSON.stringify({shop: currentState.shop}))
        if (Array.isArray(promotionValides)) {
            await promotionValides.forEach((promotionValide) => {
                dispatch(updatePromotions(promotionValide, false));
            });
        }

        dispatch(recalculerShop());
        return true;
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.message || err.response.statusText, status: err.response?.status || 500
            }
        });
        console.error(err.message || err.response.statusText);
    }
};

// Remove an item from the shopping cart
export const removeFromShoppingCart = (item, showAlert = true, lang = 'fr', reloadAfter = false) => async (dispatch, getState) => {
    try {
        if (showAlert) {
            if (lang === 'en') dispatch(setAlert(`${ item.name.toUpperCase() } removed from shopping cart`, "danger")); else dispatch(setAlert(`${ item.name.toUpperCase() } enlevé du panier`, "danger"));
        }
        clearTimeout(timeoutId);
        dispatch({
            type: REMOVE_FROM_SHOPPING_CART, payload: item
        });

        var currentState = getState();
        //la condition est juste pour permettre l'ajout des activites dans le panier cela doit disparaitre une fois que les element de l'activite sont OK
        if (item["type"]?.includes("Reservation")) {
            dispatch(clearPromotion());
            if (!(item['selectedUnite'].type_hebergement === 'AC')) {
                const promotionValides = await api.post("promotion/getPromotionApplicableAuto", JSON.stringify({shop: currentState.shop}))
                if (Array.isArray(promotionValides)) {
                    promotionValides.forEach((promotionValide) => {
                        dispatch(updatePromotions(promotionValide));
                    });
                }
            }
        }

        dispatch(recalculerShop());

        if (reloadAfter && typeof window !== 'undefined' && window.location) {
            window.location.reload();
        }
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.response.statusText, status: err.response.status
            }
        });
    }
};
export const initialzePromotion = (promotion) => async (dispatch, getState) => {
    await dispatch({
        type: INITIALIZE_PROMOTIONS, payload: promotion
    });
    await dispatch(recalculerShop());
};

export const updatePromotions = (promotion, updateDepot = null) => async (dispatch, getState) => {
    if (!promotion.isValide) dispatch(setAlert(`Code invalide`, "danger")); else {
        await dispatch({
            type: UPDATE_PROMOTIONS, payload: promotion
        });
        await dispatch(recalculerShop());
    }
};

export const clearPromotion = () => async (dispacth) => dispacth({type: CLEAR_PROMOTION});

export const recalculerShop = () => async (dispatch, getState) => {
    const shop = getState().shop;
    await dispatch({type: IS_RECALCULING, payload: true});
    const reservationItems = shop.cart.filter(item => item.type.includes("Reservation"));
    const autresItems = shop.cart.filter(item => !item.type.includes("Reservation"));

    let soustotal = 0;
    let montantDepot = {montant: 0};
    let montantTotal = 0;
    let tps = 0;
    let tvq = 0;
    let fraisAdmin = 0;
    let hebergement = 0;

    let soustotalAutre = 0;
    let soustotalAutreTaxableTps = 0;
    let soustotalAutreTaxableTvq = 0;
    let montantDepotAutre = {montant: 0};
    let tpsAutre = 0;
    let tvqAutre = 0;
    let montantTotalAutre = 0;
    let montantTotalAutreTaxableTps = 0;
    let montantTotalAutreTaxableTvq = 0;
    let fraisAdminAutre = 0;
    let hebergementAutre = 0;

    var montants = await api.post("Reservation/MontantsTotal", JSON.stringify({shop: {...shop, cart: reservationItems}}))
    montantDepot.montant = montants.montantDepots?.find((mntDepot) => mntDepot.noDepot === 1)?.montant || 0;
    soustotal = montants.montantAvantTaxes;
    montantTotal = montants.total;
    tps = montants.tps;
    tvq = montants.tvq;
    fraisAdmin = montants.fraisAdmin;
    hebergement = montants.hebergement;

    for (let item of autresItems) {
        soustotalAutre += item.montant;
        fraisAdminAutre += item.fraisAdmin;
        hebergementAutre += item.hebergement;
        if (item.montantTaxableTps) {
            soustotalAutreTaxableTps += item.montantTaxableTps;
        } else if ((item.taxableTps !== false && item.taxableTps !== 0)) soustotalAutreTaxableTps += item.montant;

        if (item.montantTaxableTvq) {
            soustotalAutreTaxableTvq += item.montantTaxableTvq;
        } else if (item.taxableTvq !== false && item.taxableTvq !== 0) soustotalAutreTaxableTvq += item.montant;
    }

    montantTotalAutreTaxableTps = soustotalAutreTaxableTps + fraisAdminAutre + hebergementAutre;
    montantTotalAutreTaxableTvq = soustotalAutreTaxableTvq + fraisAdminAutre + hebergementAutre;

    tpsAutre = roundTwoDecimals(montantTotalAutreTaxableTps * TPS);
    tvqAutre = roundTwoDecimals(montantTotalAutreTaxableTvq * TVQ);

    soustotal += soustotalAutre;
    tps += tpsAutre;
    tvq += tvqAutre;
    montantTotal += soustotalAutre + fraisAdminAutre + hebergementAutre + tpsAutre + tvqAutre;
    montantDepot = {montant: montantDepot.montant + soustotalAutre + fraisAdminAutre + hebergementAutre + tpsAutre + tvqAutre}

    let depot = (montantDepot?.montant || 0);
    dispatch({type: RECALCULER_SHOP, payload: {...shop, tps: roundTwoDecimals(tps), tvq: roundTwoDecimals(tvq), total: roundTwoDecimals(montantTotal), subtotal: roundTwoDecimals(soustotal), fraisAdmin: roundTwoDecimals(fraisAdmin), hebergement: roundTwoDecimals(hebergement), montantDepots: depot > montantTotal ? montantTotal : depot}});
}

export const removePromotions = (promotion) => async (dispatch, getState) => {
    await dispatch({
        type: REMOVE_PROMOTION, payload: promotion
    })
    await dispatch(recalculerShop());
};

export const setFraisAdmin = ({
                                  fixe, pourcent
                              }) => async (dispatch) => {
    try {
        dispatch({
            type: SET_FRAIS_ADMIN, fixe: fixe, pourcent: pourcent
        });
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.response.statusText, status: err.response.status
            }
        });
    }
};

export const setTauxTaxes = ({
                                 tps, tvq, hebergement
                             }) => async (dispatch) => {
    try {
        dispatch({
            type: SET_TAUX_TAXES, tps: tps, tvq: tvq, hebergement: hebergement
        });
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err.response.statusText, status: err.response.status
            }
        });
    }
};

export const setTimeoutShop = (idsReservationTemp) => (dispatch) => {
    if (!idsReservationTemp) return;

    const actionTimeleft = 60000; // 1 minute for execution timeoutAction
    const alertTimeleft = 30000; // 30 sec left to alert that shop item will be deleted.
    const listeners = ["click", "mousemove", "keypress"];
    listeners.forEach((name) => window.addEventListener(name, resetTimeoutShop, true));

    let databaseTimer = Date.now();
    setSessionShopLoaded(true);
    resetTimeoutShop();

    function clearTimeoutShop() {
        listeners.forEach((name) => window.removeEventListener(name, resetTimeoutShop, true));
        setSessionShopLoaded(false);
        dispatch({type: CLEAR_TIMEOUT_SHOP});
        deleteReservationTemp(idsReservationTemp);
    }

    function resetTimeoutShop() {
        const timeleft = RESERVATION_TEMP_TIMEOUT - (Date.now() - databaseTimer);
        if (timeleft <= actionTimeleft && timeleft > alertTimeleft) {
            if (timeleft > alertTimeleft) {
                updateReservationTempTimeout(idsReservationTemp);
                databaseTimer = Date.now();
            } else {
                //console.log(`showing popup countdown from ${alertTimeleft / 1000} to 0 seconds.`);
                // show alert with countdown: shopping cart will be delete in {30} sec
            }
        }

        clearTimeout(timeoutId);
        timeoutId = setTimeout(clearTimeoutShop, RESERVATION_TEMP_TIMEOUT);
    }
};

// Updater an item from the shopping cart
export const updateShop = (index, newItem, showAlert = true, lang = 'fr') => async (dispatch, getState) => {
    try {
        await dispatch({type: IS_RECALCULING, payload: true});
        if (newItem["type"].includes("Reservation")) {


            // Quels types de cart items ont 'Reservation' à part 'Reservation d'activité'?
            var montants = await calculateSumarryAmounts(newItem["selectedUnite"]);

            if (montants.montantDetailles.some(mntDetail => mntDetail.description === "Invalide")) throw new Error('Erreur lors du calcul du tarif')

            if (Object.keys(montants).length === 0) {
                newItem["fraisAdmin"] = 0;
                newItem["hebergement"] = 0;
                newItem["tps"] = newItem["montant"] * TPS;
                newItem["tvq"] = newItem["montant"] * TVQ;
                newItem["total"] = Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]);
                newItem["montantDepots"] = newItem["total"];
                newItem["montantDetail"] = [];
            } else {
                newItem["montant"] = montants.montantAvantTaxes;
                newItem["fraisAdmin"] = montants.fraisAdmin;
                newItem["hebergement"] = montants.hebergement;
                newItem["tps"] = montants.tps;
                newItem["tvq"] = montants.tvq;
                newItem["total"] = montants.total;
                /*const montantDepot = montants.montantDepots.find((mntDepot) => mntDepot.no_depot === 1);
                newItem["montantDepots"] = montantDepot ? montantDepot.montant : montants.total;
                newItem["isMontantDepotFix"] = montantDepot ? montantDepot.is_depot_fix : false;*/
                newItem["montantDetail"] = montants.montantDetailles;
            }
        } else {
            if (newItem["tps"] === undefined || newItem["tvq"] === undefined || newItem["total"] === undefined || newItem["montantDepots"] === undefined || newItem["hebergement"] === undefined || newItem["fraisAdmin"] === 0) {
                // Bloc temporaire en attendant que le site calcule les taxes correctement partout
                newItem["tps"] = newItem["taxableTps"] || newItem["taxableTps"] === undefined ? newItem["montant"] * TPS : 0;
                //newItem['tvq'] = roundTwoDecimals(newItem['montant'] * TVQ + newItem['montant'] * TPS - newItem['tps']); // Ce "+ newItem['montant'] * TPS - newItem['tps']" corrige les erreurs d'arrondissement de cents (e.g. round(3.333 + 3.333) = 6.67 mais round(3.33) + round(3.33) = 6.66. Le Manisoft met la cet supplémentaire dans la TVQ).
                newItem["tvq"] = newItem["taxableTvq"] || newItem["taxableTvq"] === undefined ? newItem["montant"] * TVQ : 0;
                newItem["total"] = Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]);
                newItem["fraisAdmin"] = 0;
                newItem["hebergement"] = 0;
                newItem["montantDepots"] = newItem["total"];
            }
        }
        // const res = await axios.get("/posts?sort=-tag,-updatedAt");
        /* if (newItem["tps"] === undefined || newItem["tvq"] === undefined || newItem["total"] === undefined) {
          // Bloc temporaire en attendant que le site calcule les taxes correctement partout
          newItem["tps"] = newItem["montant"] * TPS;
          newItem["tvq"] = newItem["montant"] * TVQ;
          newItem["total"] = Number(newItem["montant"]) + Number(newItem["tps"]) + Number(newItem["tvq"]);
        }*/

        if (showAlert) {
            if (lang === 'fr') dispatch(setAlert(newItem.name.toUpperCase() + " a été modifié avec succès", "success")); else dispatch(setAlert(newItem.name.toUpperCase() + " was successfully modified", "success"));
        }
        dispatch({
            type: UPDATE_SHOP, index: index, payload: newItem
        });
        await dispatch(clearPromotion());
        var currentState = getState();
        const promotionValides = await api.post("promotion/getPromotionApplicableAuto", JSON.stringify({shop: currentState.shop}))
        if (Array.isArray(promotionValides)) {
            await promotionValides.forEach((promotionValide) => {
                dispatch(updatePromotions(promotionValide, false));
            });
        }

        dispatch(recalculerShop());
    } catch (err) {
        dispatch({
            type: SHOP_ERROR, payload: {
                msg: err?.response?.statusText, status: err?.response?.status
            }
        });
    }
};

export const setErrorAlert = (message) => (dispatch) => {
    dispatch(setAlert(message, "danger"));
};


const getSessionIdsRsrvTemp = () => JSON.parse(sessionStorage.getItem(SessionKeys.IdS_RESERVATION_TEMP));

const getSessionShopLoaded = () => sessionStorage.getItem(SessionKeys.IS_SHOP_LOADED);

const setSessionIdsRsrvTemp = (idsResrvTempString) => sessionStorage.setItem(SessionKeys.IdS_RESERVATION_TEMP, idsResrvTempString);

const setSessionShopLoaded = (loaded) => sessionStorage.setItem(SessionKeys.IS_SHOP_LOADED, loaded);

const calculateTaxes = (array) => {
    array["tps"] = array["montant"] * TPS;
    array["tvq"] = array["montant"] * TVQ;
    array["total"] = array["montant"] + array["tps"] + array["tvq"];
    return array;
};